import React from 'react';
import Home from '../Home';
import Webimg from "../../img/dyweb.png"
import Mobimg from "../../img/mobil_web.jpeg"

// Reusable SVG Icon Components
const GlobeIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      fillRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6l-.75.75a.75.75 0 0 0 1.06 1.06l1.25-1.25a.75.75 0 0 0 .22-.53V6Z"
      clipRule="evenodd"
    />
  </svg>
);

const MobileIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 1.5H13.5C14.3284 1.5 15 2.17157 15 3V21C15 21.8284 14.3284 22.5 13.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V3C9 2.17157 9.67157 1.5 10.5 1.5Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18H12.01"
    />
  </svg>
);

const ChartPieIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM12 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    />
  </svg>
);

const CheckCircleIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6 text-green-500"
  >
    <path
      fillRule="evenodd"
      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.882l-3.484 4.195-1.958-1.594a.75.75 0 0 0-1.223.806l2.508 2.507a.75.75 0 0 0 1.135-.075l4.04-4.524Z"
      clipRule="evenodd"
    />
  </svg>
);

const BriefcaseIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21.75c-1.87 0-3.623-.5-5.25-1.5-1.627-.999-2.99-2.499-4.125-4.25-.97-1.424-1.5-3.078-1.5-4.75a6.75 6.75 0 0 1 13.5 0c0 1.672-.53 3.326-1.5 4.75-1.135 1.751-2.498 3.251-4.125 4.25-1.627 1-3.38 1.5-5.25 1.5Z"
    />
  </svg>
);

function DynamicWebsite() {
  return (
    <Home>
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 antialiased">
      {/* Tailwind CSS is assumed to be available. */}
      <script src="https://cdn.tailwindcss.com"></script>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" />
      <style>{`body { font-family: 'Inter', sans-serif; }`}</style>

      {/* Hero Section */}
      <header className="bg-gradient-to-br from-purple-600 to-purple-800 text-white py-16 px-4 sm:px-6 lg:px-8 shadow-xl">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-4">
            Empower Your Practice with a Dynamic Online Presence
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl font-light mb-8 max-w-3xl mx-auto">
            A professional website and a dedicated mobile app to connect with your patients, manage appointments, and grow your practice.
          </p>
          <button className="bg-white text-purple-600 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Request a Free Demo
          </button>
        </div>
      </header>

      {/* Benefits Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Why a Digital Platform is Essential</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-purple-500 rounded-full flex items-center justify-center mb-6">
                <GlobeIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Build Your Brand</h3>
              <p className="text-gray-600">
                Establish a credible and professional online identity that instills trust and attracts new patients.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <MobileIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Engage Patients</h3>
              <p className="text-gray-600">
                Keep your patients informed and connected with an app for secure messaging, health tips, and appointment details.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-pink-500 rounded-full flex items-center justify-center mb-6">
                <ChartPieIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Streamline Operations</h3>
              <p className="text-gray-600">
                Automate appointment booking, telemedicine sessions, and form completion to reduce administrative overhead.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Website & App Showcase */}
      <section className="bg-gray-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">A Cohesive Experience</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Our platform provides a seamless, integrated experience across both desktop and mobile devices.
          </p>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="rounded-2xl shadow-xl overflow-hidden border border-gray-200">
              <img
                src={Webimg}
                alt="Website Interface"
                className="w-full h-auto"
              />
            </div>
            <div className="rounded-2xl shadow-xl overflow-hidden border border-gray-200">
              <img
                src={Mobimg}
                alt="Mobile App Interface"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Simple, Transparent Pricing</h2>
          <p className="text-lg text-gray-600 mb-12">
            Choose the plan that fits your practice, with no hidden fees and the flexibility to upgrade anytime.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Basic Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                  <BriefcaseIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Basic</h3>
                <p className="text-gray-600 mb-4">Ideal for solo practitioners.</p>
                <p className="text-4xl font-extrabold mb-6">₹5000<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Professional Website</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Online Appointment System</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Unlimited Appointments</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Basic SEO Optimization</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Email & SMS Reminders</li>
                </ul>
              </div>
              <button className="w-full bg-purple-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-purple-700 transition-colors">
                Select Basic Plan
              </button>
            </div>
            {/* Pro Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border-2 border-purple-600 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl relative">
              <span className="absolute top-0 right-0 -mt-3 -mr-3 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">Most Popular</span>
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mb-4">
                  <BriefcaseIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Professional</h3>
                <p className="text-gray-600 mb-4">Perfect for growing practices.</p>
                <p className="text-4xl font-extrabold mb-6">₹9999<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Basic</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Dedicated Mobile App</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Integrated Telehealth</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Secure Patient Messaging</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Advanced Analytics</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />HIPAA/GDPR Compliance</li>
                </ul>
              </div>
              <button className="w-full bg-purple-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-purple-700 transition-colors">
                Select Professional
              </button>
            </div>
            {/* Enterprise Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mb-4">
                  <BriefcaseIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
                <p className="text-gray-600 mb-4">For large clinics and hospital groups.</p>
                <p className="text-4xl font-extrabold mb-6">Contact Us</p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Professional</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Custom API Integrations</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Dedicated Account Manager</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />On-site Training</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />24/7 Priority Support</li>
                </ul>
              </div>
              <button className="w-full bg-purple-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-purple-700 transition-colors">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features List */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Features Designed for Modern Practice</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-purple-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Integrated Telehealth</h3>
                <p className="text-gray-600">
                  Conduct secure video consultations directly from your website or app, expanding your reach and patient care.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-purple-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Secure Patient Messaging</h3>
                <p className="text-gray-600">
                  Enable HIPAA-compliant communication with patients for follow-ups, questions, and lab results.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-purple-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Online Appointment Booking</h3>
                <p className="text-gray-600">
                  Allow patients to book and manage appointments 24/7, reducing no-shows and freeing up your staff.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-purple-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Patient Education Resources</h3>
                <p className="text-gray-600">
                  Share articles, videos, and guides to empower your patients and enhance their understanding of their health.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">What Our Colleagues Say</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Trusted by medical professionals who are embracing the future of healthcare.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "Our new website has become our primary source of new patient leads. It's clean, professional, and easy for patients to navigate."
              </p>
              <p className="font-semibold text-purple-600">- Dr. Emily Hayes</p>
              <p className="text-sm text-gray-500">Cardiology Specialist</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "The mobile app has been a game-changer for patient communication. It's so much more efficient than playing phone tag."
              </p>
              <p className="font-semibold text-purple-600">- Dr. Marcus Reid</p>
              <p className="text-sm text-gray-500">Pediatrician</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "We were looking for a one-stop solution and this platform delivered. The integrated telehealth feature has made virtual appointments seamless."
              </p>
              <p className="font-semibold text-purple-600">- Dr. Olivia Clark</p>
              <p className="text-sm text-gray-500">General Practitioner</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Do I need both a website and a mobile app?</h3>
              <p className="text-gray-600">
                While a professional website is a great start, a mobile app provides a deeper level of patient engagement and convenience. We offer flexible packages to fit your needs.
              </p>
            </div>
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Are the platforms HIPAA compliant?</h3>
              <p className="text-gray-600">
                Yes, our platforms are built with security and privacy as a top priority. We use robust encryption and follow strict protocols to ensure full compliance with all relevant healthcare regulations, including HIPAA.
              </p>
            </div>
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Can the design be customized to my brand?</h3>
              <p className="text-gray-600">
                Absolutely. We work closely with you to ensure the website and mobile app reflect your clinic's brand identity, including logos, color schemes, and messaging.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-purple-600 text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Modernize Your Practice?</h2>
          <p className="text-lg sm:text-xl font-light mb-8">
            Take the next step in healthcare innovation. Schedule a personalized demo to see how our solutions can help you.
          </p>
          <button className="bg-white text-purple-600 font-semibold px-10 py-4 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Book Your Free Demo
          </button>
        </div>
      </section>

     
    </div>
    </Home>
  );
}

export default DynamicWebsite;


